export default [
    { name: 'Dashboard',             icon: '#dashboard',         permissionsModuleName: 'analytics.overview' },
    { name: 'Reports',               icon: '#reports',           permissionsModuleName: 'analytics' },
    { name: 'Offers',                icon: '#offers',            permissionsModuleName: 'offers.list' },
    { name: 'Publishers',            icon: '#trafficSources',    permissionsModuleName: 'partners.list' },
    { name: 'Advertisers',           icon: '#advertisers',       permissionsModuleName: 'advertisers.list' },
    { name: 'Smart Links',           icon: '#trafficSplitter',   privilegeModule:       'smart_links' },
    { name: 'Triggers',              icon: '#triggers',          permissionsModuleName: 'triggers.list' },
    { name: 'Onboarding',            icon: '#onboarding',        permissionsModuleName: 'onboarding.list' },
    { name: 'Approvals',             icon: '#approvals',         permissionsModuleName: 'approvals.list' },
    { name: 'Creatives',             icon: '#banners',           permissionsModuleName: 'banners.list' },
    { name: 'Control & Settings',    icon: '#traffic-filtering', notLinkable: true },
];
